export default {

// SECTION TOP
    title: `Committed to responsible beauty`,
    subTitle:`Sustainable goals`,
    

// CONTENT

    content1: `The cosmetics industry certainly does not escape the challenge of leadership in social and environmental responsibility, whether in its business, its production or its communication. Some groups are even changing their promotion of <span class='renvoi' data-tippy-content='Clean beauty: the trend to develop cosmetics from natural substances and without chemicals. Green beauty is also about being as transparent as possible about the composition of the products.'>clean beauty</span> products, in favor of more natural and healthy cosmetics in tune with commitment in general. They are thus pivoting from green beauty, which mainly focuses on the composition of products, to blue beauty, which aspires to proactively engage in the preservation of the environment at every step, from manufacturing through to distribution. `,

    content2: `This is a more global approach, with initiatives that meet the increased demands of consumers and eco-responsible labels. <span class='renvoi' data-tippy-content='COSMEtic Organic and natural Standard'>COSMOS certification</span> from Ecocert requires, for example, a respect for biodiversity and recyclable packaging, in addition to the absence of petrochemical ingredients (excluding authorized preservatives).`,

    title3: `A range of initiatives`,
    content3_1: `With blue beauty, the world of beauty meets that of ethics. Originally, the adjective “blue” specifically targeted the protection of the oceans. Some pioneering brands have been committed to the preservation of the marine ecosystem, alongside the foundations, for over ten years. Others have developed ocean-friendly sun protection ranges. This is a not insignificant fact considering that 25,000 tonnes of active chemical ingredients from sunscreens are dumped into the oceans every year, further jeopardizing marine ecosystems and coral reefs.`,
    content3_2: `Large groups, for their part, are now demanding that all the varioius impacts, both direct and indirect, of their activity be taken into account – the fight against climate change, responsible water management, preservation of natural resources, and so on – and are now establishing foundations for the restoration of damaged ecosystems.`,
    content3_3: `Finally, other brands are including a soil regeneration initiative in their CSR policy as well as social and local commitments by creating fair trade networks, for example. This help seal the commitment to sustainability by taking good care of both natural resources and the people involved in cosmetics production.`,
    signature: `By Cécile Cau, journalist.`,


// KEY FIGURES
    keyFigures: [
        {
            figure: 8,
            suffix: `%`,
            content: `is the rebound of the global cosmetics market in 2021 (from a total of €228 billion, of which 35% was in Asia).`,
            topImage: `Profiting_001.svg`,
            noCollapse: true,
            noMarge: true,
        },
        {
            figure: 48,
            suffix: `billion`,
            content: `dollars is the potential for the global natural cosmetics market by 2024.`,
            topImage: `Profiting_002.svg`,
            noCollapse: true,
        },

    ],


};

